import { Fragment, useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
    Grid,
    Chip,
    Card,
    CardContent
} from "@mui/material";

import { Modal, ModalBody, Button, Loading, ModalFooter, ProgressBar } from "@gpstrackit/react-controls";

import { useIntl } from "react-intl";

//Redux
import {
    vidfleetConfigurationLoadData,
    vidfleetConfigurationSave,
    vidfleetConfigurationSettingsToClone,
    showRestrictionsModal,
    showCloneSettingsModal,
    vidfleetConfigurationUploadModeLoadData,
    vidfleetConfigurationHubSpotLoadData,
    showChangesHistoryGetData,
    generateValidationCode,
    searchEntityRequest,
    openModalVidfleetConfigurationPreview,
    clearRedux,
} from "Redux/actions";

//```Steps
import FirstStep from './steps/first';
import SecondStep from './steps/second';
import ThirdStep from './steps/third'
import RestrictionsModal from "Modules/vidfleet/.components/restrictionsModal";
import CloneSettingsModal from "Modules/vidfleet/.components/cloneSettingsModal";
import ConfigurationUploadMode from "../configurationUploadMode";
import ConfigurationHubSpot from "../configurationHubSpot";
import ConfirmVidFleetConfigurationPreview from '../configurationPreview'

import { NotificationManager } from "Components/Notifications";
import { getBadget, getTimezoneOffsetList } from 'Core/data/Helpers';
import { HasPermission } from 'Core/security';

const VidfleetConfiguration = (props) => {

    const dispatch = useDispatch();
    const { messages } = useIntl();

    const firstStepRef = useRef();
    const secondStepRef = useRef();
    const thirdStepRef = useRef();

    //states reduxers
    const { loading, data, saveResult, settingsToClone, loadingSettingsToClone, openModal } = useSelector(state => state.vidfleetConfigurationRedux);
    const configurationUploadModeOpenModal = useSelector(state => state.vidfleetConfigurationUploadModeRedux.openModal);
    const configurationHubSpotOpenModal = useSelector(state => state.vidfleetConfigurationHubSpotRedux.openModal);
    const openModalConfigurationPreview = useSelector(state => state.configurationPreviewRedux.openModal);

    const { loadingVfCode, VfCodeResult } = useSelector(state => state.commonRedux);
    const manufacturers = useSelector(state => state.generalRedux.manufacturers);
    const user = useSelector(state => state.securityRedux.user);

    //locals states
    const [activeStep, setActiveStep] = useState((props.single || !props.bulk) ? 1 : 0);
    const [devices, setDevices] = useState([]);
    const [restrictions, setRestrictions] = useState([]);
    const [applyScopes, setApplyScopes] = useState(["Partial"]);
    const [settings, setSettings] = useState({});
    const [initialSettings, setInitialSettings] = useState({});
    const [defaultManufacturer, setDefaultManufacturer] = useState({});
    const [settingsDataChanged, setSettingsDataChanged] = useState({ settings: {} });
    const [optionLabels, setOptionLabels] = useState([]);
    const [cloneSettings, setCloneSettings] = useState(false);
    const [settingsData, setSettingsData] = useState(null);
    const [defaults, setDefaults] = useState(null);
    const [isOpenMessageClone, setIsOpenMessageClone] = useState(false);
    const [deviceToClone, setDeviceToClone] = useState(false);
    const [verificationCode, setVerificationCode] = useState("");
    const [sentVFCC, setSentVFCC] = useState(false);
    const [codeSent, setCodeSent] = useState(false);
    const [timezonesWaylens, setTimezonesWaylens] = useState([]);
    const [settingsFromFleetAPIRaw, setSettingsFromFleetAPIRaw] = useState({})


    const onValidSubmit = () => {
        switch (activeStep) {
            case 0:
                nextStep();
                break;

            case 1:
                nextStep();
                break;
            case 2:
                break;
        }
    }

    const applyScopesChange = (applyScopes) => {
        setApplyScopes([...applyScopes]);
    }

    const devicesChange = (devices) => {
        setDevices([...devices]);
    }

    const dataChange = (settings, optionLabels, cloneSettings, defaults, settingsData, deviceToClone, initialSettings, defaultManufacturer, settingsDataChanged, settingsFromFleetAPIRaw) => {
        setSettings(settings);
        setOptionLabels(optionLabels);
        setCloneSettings(cloneSettings);
        setDefaults(defaults);
        setSettingsData(settingsData);
        setDeviceToClone(deviceToClone);
        setInitialSettings(initialSettings);
        setDefaultManufacturer(defaultManufacturer);
        setSettingsDataChanged(settingsDataChanged);
        setSettingsFromFleetAPIRaw(settingsFromFleetAPIRaw)
    }

    const prevStep = () => {
        setActiveStep(activeStep - 1);
    }

    const nextStep = () => {
        setActiveStep(activeStep + 1);
    }

    const checkPropertyChange = (obj) => {
        if (!obj) return false;
        let keys = Object.keys(obj);
        for (const key of keys) {
            if (Array.isArray(obj[key])) {
                for (const item of obj[key]) {
                    if (item) return true;
                }
            } else if (typeof obj[key] === 'object') {
                if (checkPropertyChange(obj[key])) return true;
            } else if (obj[key]) {
                return true;
            }
        }
        return false;
    }

    //only used on bulk mode
    const close = () => {
        dispatch(clearRedux("VIDFLEET_CONFIGURATION"));
        setDevices([]);
        setActiveStep(props.single ? 1 : 0);
        setApplyScopes(["Partial"]);
        setOptionLabels([]);
        setSettings({});
        setDefaults(null);
        setCloneSettings(false);
        setIsOpenMessageClone(false);
        setCodeSent(false);
        //if bulk mode
        //dispatch(bulkVidFleetConfigModalHide());

    }

    const applySettingsClone = () => {

        let data = { config: settings }
        data.devices = devices;

        if (applyScopes.includes("Partial")) {
            data.applyScopes = applyScopes;
        } else {
            data.applyScopes = applyScopes;
        }

        if (data?.config?.nightVision?.drivingNightVision !== "on" && data?.config?.nightVision?.drivingNightVisionTime) {
            delete data?.config?.nightVision?.drivingNightVisionTime;
        }

        if (data?.config?.obdII?.mode !== "Auto" && data?.config?.obdII?.voltage) {
            delete data?.config?.obdII?.voltage;
        }

        if (data?.config?.timezone) {
            if (data?.config?.timezone.includes("/"))
                data.config.advanced.subtitle.timezone = "name";
            else
                data.config.advanced.subtitle.timezone = "GMT%z";
        }
        data.bulk = true;
        dispatch(vidfleetConfigurationSave(data));
    }

    //render steps
    const getStepsRender = (step) => {
        switch (step) {
            case 0:
                return (
                    <FirstStep
                        ref={firstStepRef}
                        onValidSubmit={onValidSubmit}
                        messages={messages}
                        devicesChange={devicesChange}
                        devices={devices}
                        single={props.single}
                        permissions={props.permissions}
                        applyScopesChange={applyScopesChange}
                        applyScopes={applyScopes}
                        clearRedux={clearRedux}
                        defaults={defaults}
                        bulk={props.bulk}
                        getBadget={getBadget}
                    />
                )
            case 1:
                return (
                    <SecondStep
                        ref={secondStepRef}
                        onValidSubmit={onValidSubmit}
                        messages={messages}
                        devicesChange={devicesChange}
                        dataChange={dataChange}
                        devices={devices}
                        vidfleetConfigurationSave={vidfleetConfigurationSave}
                        vidfleetConfigurationSettingsToClone={vidfleetConfigurationSettingsToClone}
                        nextStep={nextStep}
                        applyScopes={applyScopes}
                        close={close}
                        permissions={props.permissions}
                        settingsToClone={settingsToClone}
                        settingsToCloneLoading={loadingSettingsToClone}
                        settingsData={settingsData}
                        initialSettings={initialSettings}
                        defaultManufacturer={defaultManufacturer}
                        defaults={defaults}
                        clearRedux={clearRedux}
                        deviceToClone={deviceToClone}
                        restrictions={restrictions}
                        setRestrictions={setRestrictions}
                        bulk={props.bulk}
                        device={props.device}
                        getBadget={getBadget}
                        showRestrictionsModal={showRestrictionsModal}
                        vidfleetConfigurationUploadModeLoadData={vidfleetConfigurationUploadModeLoadData}
                        vidfleetConfigurationHubSpotLoadData={vidfleetConfigurationHubSpotLoadData}
                        showChangesHistoryGetData={showChangesHistoryGetData}
                        verificationCode={verificationCode}
                        setVerificationCode={setVerificationCode}
                        generateValidationCode={generateValidationCode}
                        manufacturers={manufacturers}
                        setSentVFCC={setSentVFCC}
                        setCodeSent={setCodeSent}
                        codeSent={codeSent}
                        getTimezoneOffsetList={getTimezoneOffsetList}
                        timezonesWaylens={timezonesWaylens}
                        setTimezonesWaylens={setTimezonesWaylens}
                        settingsDataChanged={settingsDataChanged}
                        setSettingsDataChanged={setSettingsDataChanged}
                        settingsFromFleetAPIRaw={settingsFromFleetAPIRaw}
                        cloneSettings={cloneSettings}
                        setCloneSettings={setCloneSettings}
                        from={props.from}
                        openModalVidfleetConfigurationPreview={openModalVidfleetConfigurationPreview}

                    />
                )
            case 2:
                return (
                    <ThirdStep
                        ref={thirdStepRef}
                        onValidSubmit={onValidSubmit}
                        messages={messages}
                        devices={devices}
                        settings={settings}
                        optionLabels={optionLabels}
                        close={close}
                        applyScopes={applyScopes}
                        vidfleetConfigurationSave={vidfleetConfigurationSave}
                        verificationCode={verificationCode}
                        setVerificationCode={setVerificationCode}
                        generateValidationCode={generateValidationCode}
                        manufacturers={manufacturers}
                        setSentVFCC={setSentVFCC}
                        setCodeSent={setCodeSent}
                        codeSent={codeSent}
                    />
                )
            default:
                return (<div>empty</div>)
        }
    }

    const getComponentRender = () => {

        if (props.bulk) {
            return (
                <Modal
                    open={openModal}
                    title={messages['vidfleet_configuration_title_bulk']}
                    size="large"
                    position="right"
                    handleClose={() => close()}
                >
                    <ModalBody>
                        <div className="" style={{ width: '100%' }}>
                            <ProgressBar
                                steps={3}
                                activeStep={activeStep}
                            />
                        </div>
                        <div style={{ padding: '0 10px', height: activeStep === 3 && '78vh' }}>
                            {getStepsRender(activeStep)}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            {
                                (activeStep < 3)
                                &&
                                <Button size="lg" className="btn btn-cancel"
                                    onClick={() => {
                                        close();
                                    }}
                                    disabled={loading}
                                >
                                    {messages["common_cancel"]}
                                </Button>
                            }

                            {
                                (activeStep > 0 && activeStep < 3) &&
                                !props.single &&
                                <Button
                                    size="lg" className="btn btn-dark-blue"
                                    onClick={() => { prevStep() }}
                                    disabled={loading}
                                >
                                    {
                                        applyScopes.includes("Partial") && activeStep === 1 &&
                                        messages["vidfleet_configuration_add_more_devices"]
                                    }
                                    {
                                        applyScopes.includes("Partial") && activeStep === 2 &&
                                        messages["common_back"]
                                    }
                                    {
                                        !applyScopes.includes("Partial") && activeStep > 0 &&
                                        messages["common_back"]
                                    }
                                </Button>
                            }

                            {
                                activeStep < 3 &&
                                <Button
                                    size="lg" className="btn btn-dark-blue"
                                    onClick={() => {
                                        if (activeStep === 0) {
                                            nextStep();
                                        } else if (activeStep === 1) {
                                            if (secondStepRef && secondStepRef.current)
                                                secondStepRef.current.onSubmit();
                                        } else if (activeStep === 2) {

                                            if (!cloneSettings) {

                                                let data = { config: settings }
                                                data.devices = devices;

                                                data.applyScopes = applyScopes;
                                                data.bulk = true;
                                                data.verificationCode = verificationCode;

                                                dispatch(vidfleetConfigurationSave(data));
                                            } else {
                                                dispatch(showCloneSettingsModal());
                                            }

                                        }
                                    }}
                                    disabled={
                                        loading ||
                                        ((applyScopes.includes("Partial") && ((devices && devices.length === 0)) || applyScopes?.length === 0)) ||
                                        (applyScopes.includes("Default") && (!HasPermission(user, "vftcsd", "u") || (activeStep === 2 && verificationCode === "") || applyScopes?.length === 0)) ||
                                        (applyScopes.includes("All") && (!HasPermission(user, "vftcsa", "u") || (activeStep === 2 && verificationCode === "") || applyScopes?.length === 0)) ||
                                        (activeStep === 1 && !checkPropertyChange(settingsDataChanged?.settings || {}))
                                    }
                                >
                                    {activeStep == 2
                                        ?
                                        (applyScopes.includes("Partial") ? `${messages["vidfleet_configuration_apply_settings"]} ${devices.length} ${messages["vidfleet_configuration_apply_settings_to_devices"]}` : `${messages["vidfleet_configuration_apply_settings"]}`)
                                        :
                                        messages["common_next"]
                                    }
                                </Button>
                            }
                        </div>
                    </ModalFooter>
                </Modal>
            )
        } else {
            return (
                <Grid item xs={12} className="pt-4">
                    {getStepsRender(activeStep)}
                </Grid>
            )
        }
    }

    const updateaAfterSave = () => {
        if (secondStepRef && secondStepRef.current) {
            secondStepRef.current.updateSaveSettingsAvailable()
        }

        setCodeSent(false);
        setVerificationCode("");

    }

    useEffect(() => {
        if (saveResult) {
            dispatch(clearRedux("VIDFLEET_CONFIGURATION", { saveResult: null }))
            if (!saveResult.error) {
                if (saveResult.res) {
                    NotificationManager.success(
                        '',
                        messages["vidfleet_configuration_vidfleet_config_save_accepted"],
                        3000,
                        null,
                        null,
                        'success'
                    );
                } else {
                    NotificationManager.success(
                        '',
                        messages["vidfleet_configuration_vidfleet_config_sent"],
                        3000,
                        null,
                        null,
                        'success'
                    );
                }

                if (secondStepRef && secondStepRef.current) {
                    secondStepRef.current.updateSaveSettingsAvailable()
                }
                //call to hide
                if (props.bulk)
                    close();

                setCodeSent(false);
                setVerificationCode("");
            }
            else {
                let message = messages["vidfleet_configuration_save_error"]
                if (saveResult.error && saveResult.error.error) {
                    if (messages[saveResult.error.error])
                        message = messages[saveResult.error.error]
                    else
                        message = saveResult.error.error.replace("Bad request ->", "").replace("GraphQL error: ", "")
                }

                //Error message
                NotificationManager.error(
                    messages["vidfleet_configuration_title"],
                    message,
                    3000,
                    null,
                    null,
                    'error'
                );

                setCodeSent(false);
            }
        }
        if (VfCodeResult && sentVFCC) {
            dispatch(clearRedux("COMMON", { VfCodeResult: null }));
            setSentVFCC(false)
            if (!VfCodeResult.error) {
                if (VfCodeResult.result) {
                    NotificationManager.success(
                        '',
                        messages["vidfleet_configuration_vf_code_sent"],
                        3000,
                        null,
                        null,
                        'success'
                    );
                } else {
                    //Error message
                    NotificationManager.error(
                        messages["vidfleet_configuration_title"],
                        messages["vidfleet_configuration_vf_code_error"],
                        3000,
                        null,
                        null,
                        'error'
                    );
                }
            } else {
                //Error message
                NotificationManager.error(
                    messages["vidfleet_configuration_title"],
                    messages["vidfleet_configuration_vf_code_error"],
                    3000,
                    null,
                    null,
                    'error'
                );
            }
            //message verification code send
        }
    }, [saveResult, VfCodeResult])

    useEffect(() => {
        (!manufacturers || manufacturers?.length === 0) && dispatch(searchEntityRequest({ key: "manufacturers" }))

        dispatch(vidfleetConfigurationLoadData(props?.device?.esn))
        if (!props?.bulk) {
            if (props?.device) {
                setDevices([props.device])
            }
        }
        if (props?.devices) {
            setDevices([...props.devices])
        }
    }, []);


    return (
        <Fragment>
            {(loading || loadingVfCode || loadingSettingsToClone) && <Loading overlay show />}
            {getComponentRender()}
            <RestrictionsModal />
            <CloneSettingsModal applySettingsClone={applySettingsClone} />

            {
                configurationUploadModeOpenModal &&
                <ConfigurationUploadMode initialDevices={devices} device={devices[0]} mode={props.bulk ? "Bulk" : "Single"} from={props?.from} />
            }
            {
                configurationHubSpotOpenModal &&
                <ConfigurationHubSpot initialDevices={devices} device={devices[0]} mode={props.bulk ? "Bulk" : "Single"} from={props?.from} />
            }
            {
                openModalConfigurationPreview &&
                <ConfirmVidFleetConfigurationPreview updateaAfterSave={updateaAfterSave} />
            }

        </Fragment>
    )

}
export default VidfleetConfiguration;